import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import Image from "components/Image";
import MissionIconLogo from "assets/images/gradient-mission-logo.png";
import BRANDS, { BRAND_CONFIG, BRAND_LOGO_VARIANTS, getCurrentBrand, isTalentSimpleBrand } from "constants/brands";
import { WhiteLogo, TalentSimpleLogo, MarketingLogo } from "components/Logo";

/**
 * BrandLogo
 *
 * Logo of a brand, by default the one served on the current host
 *
 * @param {String}   variant   One of BRAND_LOGO_VARIANTS: the wordmark, the square icon, or the marketing logo
 * @param {String}   fill      Wordmark color
 * @param {String}   brand     One of BRANDS, when the logo is not the current host's
 */
const BrandLogo = ({ variant = BRAND_LOGO_VARIANTS.wordmark, fill, brand = getCurrentBrand(), ...props }) => {
  const intl = useIntl();
  const alt = intl.formatMessage({ id: BRAND_CONFIG[brand].logoAltId });

  if (isTalentSimpleBrand(brand)) {
    return <TalentSimpleLogo variant={variant} fill={fill} alt={alt} {...props} />;
  }

  if (variant === BRAND_LOGO_VARIANTS.icon) {
    return <Image url={MissionIconLogo} alt={alt} {...props} />;
  }

  if (variant === BRAND_LOGO_VARIANTS.marketing) {
    return <MarketingLogo role="img" aria-label={alt} {...props} />;
  }

  return <WhiteLogo fill={fill} aria-label={alt} {...props} />;
};

BrandLogo.propTypes = {
  variant: PropTypes.oneOf(Object.values(BRAND_LOGO_VARIANTS)),
  fill: PropTypes.string,
  brand: PropTypes.oneOf(Object.values(BRANDS)),
};

export default BrandLogo;
